module.exports = __webpack_public_path__ + "static/media/i-shop.0d411bba.png";